/* eslint-disable no-unused-vars */
import React, { FC, Fragment, useEffect, useState } from 'react'
import state from '../../../../../../Data/state.json'
import lga from '../../../../../../Data/lga.json'
import './BasicInfo.scss'

interface dataTypes {
  register: any,
  errors: any,
  handleChange: (Value: any) => void,
  values: any,
  saveV: any
}
const BasicInfo: FC<dataTypes> = ({ register, errors, handleChange, values, saveV }) => {
  const dashroute = localStorage.getItem('__userRole')
  const isOfficer = dashroute === 'pscreen_officer'
  const [lgState, setLgState] = useState<any>()
  const Fetchglg = () => {
    if (saveV !== undefined) {
      return (
        <div>
          {state.map((item: any) => (
            item.data !== undefined && item.data.map((data: any) => {
              // console.log('HHH', data)
              return (
                <span key={data.id}>
                  {data.name === saveV ? <>{data.name} {setLgState(data.id)}</> : <>{saveV}</>}
                </span>
              )
            })
          ))}
        </div>
      )
    }
    return null // or some default content if saveV is undefined
  }

  useEffect(() => {
    Fetchglg()
  }, [saveV])

  return (
    <div className="basic-info-modern">
      <div className="form-card">
        <div className="form-card-header">
          <div className="header-icon">
            <i className="fa fa-user"></i>
          </div>
          <h3 className="header-title">Basic Information</h3>
        </div>
        <div className="form-card-body">
          <div className="container-fluid">
            <div className="row justify-content-between">
              {
                isOfficer
                  ? <div className='col-lg-4 col-md-12 col-sm-12 rounded-0'>
                    <label>First Name <span className='text-danger'>*</span></label>

                    <input type="text" readOnly className='form-control' {...register('firstname', { required: 'Please insert your firstname' })} onChange={handleChange} />
                    {errors.firstname && <span className='text-danger'>{errors.firstname.message}</span>}
                  </div>
                  : <div className='col-lg-4 col-md-12 col-sm-12 rounded-0'>
                    <label>First Name <span className='text-danger'>*</span></label>

                    <input type="text" className='form-control' {...register('firstname', { required: 'Please insert your firstname' })} onChange={handleChange} />
                    {errors.firstname && <span className='text-danger'>{errors.firstname.message}</span>}
                  </div>
              }

              {isOfficer
                ? <div className="col-lg-4 col-md-12 col-sm-12">
                  <label>Middle Name</label>
                  <input type={'text'} readOnly className='form-control' {...register('middlename')} onChange={handleChange} />
                  {errors.middlename && <span className='text-danger'>{errors.middlename.message}</span>}
                </div>
                : <div className="col-lg-4 col-md-12 col-sm-12">
                  <label>Middle Name</label>
                  <input type={'text'} className='form-control' {...register('middlename')} onChange={handleChange} />
                  {errors.middlename && <span className='text-danger'>{errors.middlename.message}</span>}
                </div>
              }
              {
                isOfficer
                  ? <div className="col-lg-4 col-md-12 col-sm-12">
                    <label>Surname <span className="text-danger">*</span></label>
                    <input type={'text'} readOnly className='form-control' {...register('surname', { required: 'Please Insert your Surname' })} onChange={handleChange} />
                    {errors.surname && <span className='text-danger'>{errors.surname.message}</span>}
                  </div>
                  : <div className="col-lg-4 col-md-12 col-sm-12">
                    <label>Surname <span className="text-danger">*</span></label>
                    <input type={'text'} className='form-control' {...register('surname', { required: 'Please Insert your Surname' })} onChange={handleChange} />
                    {errors.surname && <span className='text-danger'>{errors.surname.message}</span>}
                  </div>
              }

            </div>
            <div className="row">
              {
                isOfficer
                  ? <div className="col-lg-4 col-md-12 col-sm-12">
                    <label>Gender <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      style={{ height: '45px' }}
                      value={values.gender === 'm' ? 'Male' : 'Female'}
                      readOnly
                    />
                  </div>
                  : <div className="col-lg-4 col-md-12 col-sm-12">
                    <label>Gender <span className="text-danger">*</span></label>
                    <select id="" className="form-control" style={{ height: '45px' }} {...register('gender', { required: 'Please Insert your Gender' })} onChange={handleChange} >
                      {values.gender === 'm' ? <option>Male</option> : <option>Female</option>}
                      <option value="m">Male</option>
                      <option value="f">Female</option>
                    </select>
                    {errors.gender && <span className='text-danger'>{errors.gender.message}</span>}
                  </div>
              }

              {isOfficer
                ? <div className="col-lg-4 col-md-12 col-sm-12">
                  <label>Date of birth <span className="text-danger">*</span></label>
                  <input type="text" id="" className='form-control' readOnly {...register('dob', { required: 'please fill in date of birth' })} onChange={handleChange} />
                  {errors.dob && <span className='text-danger'>{errors.dob.message}</span>}
                </div>
                : <div className="col-lg-4 col-md-12 col-sm-12">
                  <label>Date of birth <span className="text-danger">*</span></label>
                  <input type="text" id="" className='form-control' {...register('dob', { required: 'please fill in date of birth' })} onChange={handleChange} />
                  {errors.dob && <span className='text-danger'>{errors.dob.message}</span>}
                </div>
              }

              {isOfficer
                ? <div className="col-lg-4 col-md-12 col-sm-12">
                  <label>Age</label>
                  <input type="text" id="" className='form-control' readOnly {...register('age', { required: 'please fill in your age' })} onChange={handleChange} />
                  {errors.age && <span className='text-danger'>{errors.age.message}</span>}
                </div>
                : <div className="col-lg-4 col-md-12 col-sm-12">
                  <label>Age</label>
                  <input type="text" id="" className='form-control' {...register('age', { required: 'please fill in your age' })} onChange={handleChange} />
                  {errors.age && <span className='text-danger'>{errors.age.message}</span>}
                </div>

              }
            </div>
            < div className="row">

              {isOfficer
                ? <div className='col-lg-4 col-md-12 col-sm-12'>

                  <label>Email <span className="text-danger">*</span></label>
                  <input type="email" id="" readOnly required className='form-control' {...register('email', { required: 'Please Insert your correct email' })} onChange={handleChange} />
                  {errors.email && <span className='text-danger'>{errors.email.message}</span>}
                </div>
                : <div className='col-lg-4 col-md-12 col-sm-12'>

                  <label>Email <span className="text-danger">*</span></label>
                  <input type="email" id="" required className='form-control' {...register('email', { required: 'Please Insert your correct email' })} onChange={handleChange} />
                  {errors.email && <span className='text-danger'>{errors.email.message}</span>}
                </div>
              }
              {isOfficer
                ? < div className="col-lg-4 col-md-12 col-sm-12">

                  <label>Phone 1 <span className="text-danger">*</span></label>
                  <input type="text" id="" required readOnly className='form-control' {...register('phone', { required: 'Please Insert your mobile number ' })} onChange={handleChange} />
                  {errors.phone && <span className='text-danger'>{errors.phone.message}</span>}
                </div>
                : < div className="col-lg-4 col-md-12 col-sm-12">

                  <label>Phone 1 <span className="text-danger">*</span></label>
                  <input type="text" id="" required className='form-control' {...register('phone', { required: 'Please Insert your mobile number ' })} onChange={handleChange} />
                  {errors.phone && <span className='text-danger'>{errors.phone.message}</span>}
                </div>
              }
              {isOfficer
                ? < div className='col-lg-4 col-sm-12 col-md-12'>
                  <label>Phone 2</label>
                  <input type="text" className='form-control' readOnly {...register('phone2')} onChange={handleChange} />
                  {errors.phone2 && <span className='text-danger'>{errors.phone2.message}</span>}
                </div>
                : < div className='col-lg-4 col-sm-12 col-md-12'>
                  <label>Phone 2</label>
                  <input type="text" className='form-control' {...register('phone2')} onChange={handleChange} />
                  {errors.phone2 && <span className='text-danger'>{errors.phone2.message}</span>}
                </div>
              }

              {isOfficer
                ? < div className='col-lg-4 col-sm-12 col-md-12'>
                  <label>Marital Status</label>
                  <input type="text" className='form-control' readOnly {...register('maritalStatus')} onChange={handleChange} />
                  {errors.maritalStatus && <span className='text-danger'>{errors.maritalStatus.message}</span>}
                </div>
                : < div className='col-lg-4 col-sm-12 col-md-12'>
                  <label>Marital Status</label>
                  <input type="text" className='form-control' {...register('maritalStatus')} onChange={handleChange} />
                  {errors.maritalStatus && <span className='text-danger'>{errors.maritalStatus.message}</span>}
                </div>}
              {isOfficer
                ? < div className='col-lg-4 col-sm-12 col-md-12'>
                  <label>Nin</label>
                  <input type="text" className='form-control' readOnly {...register('nin')} onChange={handleChange} />
                  {errors.nin && <span className='text-danger'>{errors.nin.message}</span>}
                </div>
                : < div className='col-lg-4 col-sm-12 col-md-12'>
                  <label>Nin</label>
                  <input type="text" className='form-control' {...register('nin')} onChange={handleChange} />
                  {errors.nin && <span className='text-danger'>{errors.nin.message}</span>}
                </div>}
              {
                isOfficer
                  ? < div className='col-lg-4 col-sm-12 col-md-12' >
                    <label>Street Address of Permanent Residence </label>
                    <input type="text" className='form-control' readOnly {...register('streetAddressOfPermanent')} onChange={handleChange} />
                    {errors.streetAddressOfPermanent && <span className='text-danger'>{errors.streetAddressOfPermanent.message}</span>}
                  </div >
                  : < div className='col-lg-4 col-sm-12 col-md-12' >
                    <label>Street Address of Permanent Residence </label>
                    <input type="text" className='form-control' {...register('streetAddressOfPermanent')} onChange={handleChange} />
                    {errors.streetAddressOfPermanent && <span className='text-danger'>{errors.streetAddressOfPermanent.message}</span>}
                  </div >
              }
              {
                isOfficer
                  ? < div className='col-lg-4 col-sm-12 col-md-12' >
                    <label>State of Permanent Residence </label>
                    <input type="text" className='form-control' style={{ height: '45px' }} readOnly {...register('stateOfPermanent')} />
                    {errors.stateOfPermanent && <span className='text-danger'>{errors.stateOfPermanent.message}</span>}
                  </div >
                  : < div className='col-lg-4 col-sm-12 col-md-12' >
                    <label>State of Permanent Residence </label>
                    <select {...register('stateOfPermanent')} onChange={handleChange} className='form-control' style={{ height: '45px' }}>
                      {state.map((item: any) => {
                        const dataItem = item.data
                        // console.log('DD', dataItem)
                        return <Fragment key={item.id}>{dataItem && dataItem.map((data: any) => {
                          // setLgState(data)
                          return <option key={data?.id} value={data?.name}>{data?.name}</option>
                        })
                        }
                        </Fragment>
                      })
                      }
                    </select>
                    {errors.stateOfPermanent && <span className='text-danger'>{errors.stateOfPermanent.message}</span>}
                  </div >}
              {
                isOfficer
                  ? < div className='col-lg-4 col-sm-12 col-md-12' >
                    <label>LGA of Permanent Residence </label>
                    <input type="text" className='form-control' readOnly {...register('lgaOfPermanent')} onChange={handleChange} />
                    {errors.lgaOfPermanent && <span className='text-danger'>{errors.lgaOfPermanent.message}</span>}
                  </div >
                  : < div className='col-lg-4 col-sm-12 col-md-12' >
                    <label>LGA of Permanent Residence </label>
                    {saveV !== undefined
                      ? <select {...register('lgaOfPermanent')} onChange={handleChange} className='form-control'>
                        {
                         lga !== undefined && lga.map((item: any) => {
                           return <Fragment key={item.id}>{
                              item.data !== undefined && item.data.map((data: any) => {
                                return <>
                                {data.state_id === lgState ? <option key={data.id} value={data.name}>{data.name}</option> : <></>}
                                </>
                              })
                            }</Fragment>
                         })
                        }
                    </select>
                      : <input type="text" className='form-control' {...register('lgaOfPermanent')} onChange={handleChange} />
                      }
                    {errors.lgaOfPermanent && <span className='text-danger'>{errors.lgaOfPermanent.message}</span>}
                  </div >}
              {
                isOfficer
                  ? < div className='col-lg-4 col-sm-12 col-md-12' >
                    <label>State of Residence </label>
                    <input type="text" className='form-control' readOnly {...register('stateOfResidence')} onChange={handleChange} />
                    {errors.stateOfResidence && <span className='text-danger'>{errors.stateOfResidence.message}</span>}
                  </div >
                  : < div className='col-lg-4 col-sm-12 col-md-12' >
                    <label>State of Residence </label>
                    <input type="text" className='form-control' {...register('stateOfResidence')} onChange={handleChange} />
                    {errors.stateOfResidence && <span className='text-danger'>{errors.stateOfResidence.message}</span>}
                  </div >}
              {
                isOfficer
                  ? < div className='col-lg-4 col-sm-12 col-md-12' >
                    <label>LGA of Residence </label>
                    <input type="text" className='form-control' readOnly {...register('lgaOfResidence')} onChange={handleChange} />
                    {errors.lgaOfResidence && <span className='text-danger'>{errors.lgaOfResidence.message}</span>}
                  </div >
                  : < div className='col-lg-4 col-sm-12 col-md-12' >
                    <label>LGA of Residence </label>
                    <input type="text" className='form-control' {...register('lgaOfResidence')} onChange={handleChange} />
                    {errors.lgaOfResidence && <span className='text-danger'>{errors.lgaOfResidence.message}</span>}
                  </div >}
              {
                isOfficer
                  ? < div className='col-lg-4 col-sm-12 col-md-12' >
                    <label>Street Address of Residence </label>
                    <input type="text" className='form-control' readOnly {...register('streetAddressOfResidence')} onChange={handleChange} />
                    {errors.streetAddressOfResidence && <span className='text-danger'>{errors.streetAddressOfResidence.message}</span>}
                  </div >
                  : < div className='col-lg-4 col-sm-12 col-md-12' >
                    <label>Street Address of Residence </label>
                    <input type="text" className='form-control' {...register('streetAddressOfResidence')} onChange={handleChange} />
                    {errors.streetAddressOfResidence && <span className='text-danger'>{errors.streetAddressOfResidence.message}</span>}
                  </div >}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BasicInfo
